import React from 'react';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
dayjs.extend(duration);

function toDuration(milliseconds: number) {
    const seconds = Math.floor(milliseconds / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);

    return {
        hours,
        minutes: minutes % 60,
        seconds: seconds % 60,
    };
}

export default ({ ms }: { ms: number }) => {
    const d = toDuration(ms);
    const f = d.hours > 0 ? 'HH:mm:ss' : 'mm:ss';

    return <>{dayjs.duration(d).format(f)}</>;
};
